import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// TODO: Add Angular decorator.
@Injectable({
    providedIn: 'root'
})
export class SubscriptionBaseComponent implements OnDestroy {

    subscription: Subscription = new Subscription();

    constructor() { }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}
